//ZPAL-GLOBAL
export const FETCH_RAW_LIST = '@@fetch-raw-List';
export const FETCH_RAW_LIST_SUCCESS = '@@fetch-raw-List-success';
export const FETCH_RAW_LIST_FAILURE = '@@fetch-raw-List-failure';